import type { HealthOverviewParameter, HealthParameterKey } from '@/domain/health';

/**
 * Cage-health sidebar order. Wounds and deformities list every parameter key in sequence
 * (body + snout; spine + jaw + gill lid), not grouped into a single overview row.
 */
export const HEALTH_OVERVIEW_NAVIGATION_PARAMETER_ORDER: readonly HealthParameterKey[] = [
    'bodyWounds',
    'snoutWounds',
    'scaleLoss',
    'skinBleeding',
    'finDamage',
    'emaciation',
    'deformity',
    'deformedJaw',
    'gillLid',
    'cataract',
    'eyeDamage',
    'maturity',
];

export function sortHealthOverviewParametersByNavigationOrder(
    parameters: HealthOverviewParameter[]
): HealthOverviewParameter[] {
    const rankByKey = new Map(
        HEALTH_OVERVIEW_NAVIGATION_PARAMETER_ORDER.map((key, index) => [key, index])
    );

    return [...parameters].sort((a, b) => {
        const rankA = rankByKey.get(a.key) ?? Number.MAX_SAFE_INTEGER;
        const rankB = rankByKey.get(b.key) ?? Number.MAX_SAFE_INTEGER;
        return rankA - rankB;
    });
}
